const reactEnv = {
  url: {
    API_URL_AZURE: process.env.REACT_APP_API_URL_AZURE,
    API_URL_DM05: process.env.REACT_APP_API_URL_DM05,
    API_PORT: process.env.REACT_APP_API_PORT
  }
};

export const config = reactEnv;
